import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button } from "@mui/material";
import { useLanguageContext } from "../../../Context/LanguageContext";
import AddBezeichnung from "./AddBezeichnung";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import commonUtils from "../../../helpers/commonUtils";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import ImportComponent from "../../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../../Actions/ImportAction";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const BezeichnungList = (props) => {
  const [bezeichnungDetails, setBezeichnungDetails] = useState("");
  const [bezerichnunList, setBezerichnunList] = useState(null);
  const [resBezerichnunList, setResBezerichnunList] = useState([]);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const updateSelectedConfig = useSelectedConfigActionContext();
  const columns = [
    {
      field: "bezeichnung",
      headerName: localization.nameOfEquipment,
      hideable: false,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
  ];
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importEqName,
    subHeaderTitle: localization.importEqNameTitle,
    key: "",
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);

  //------------------------Get Bezeichnung start ----------------------
  const getEquipmentList = () => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getEquipment("");
  };

  useEffect(() => {
    getEquipmentList();

    function getEquipmentListSuccess() {
      var res = equipmentGroupStore.getEquipment();

      if (res.length > 0) {
        setBezerichnunList(res);
        setResBezerichnunList(res);
      } else {
        setResBezerichnunList(res);
        setBezerichnunList(res);
      }
      setGlobalSpinner(false);
      updateSelectedConfig("Name of equipment");
    }

    function getEquipmentListFailure() {
      setGlobalSpinner(false);
      updateSelectedConfig("Name of equipment");
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQUIPMENT_SUCCESS,
      getEquipmentListSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_EQUIPMENT_FAILURE,
      getEquipmentListFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQUIPMENT_SUCCESS,
        getEquipmentListSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_EQUIPMENT_FAILURE,
        getEquipmentListFailure,
      );
    };
  }, []);

  //------------------------Get Bezeichnung end ----------------------

  //------------------------Add Bezeichnung start ----------------------
  useEffect(() => {
    function addorUpdateEquipmentSuccess() {
      var res = equipmentGroupStore.getAddorUpdateEquipmentResult();
      if (res) {
        commonUtils.hideModalPopUp("addBezeichnungModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.equipmentEditedSuccessfully
            : localization.equipmentAddedSuccessfully,
        );
      } else {
        toast.error(res);
      }
      getEquipmentList();
    }

    function addorUpdateEquipmentFailure() {
      var res = equipmentGroupStore.getAddorUpdateEquipmentResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_SUCCESS,
      addorUpdateEquipmentSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_FAILURE,
      addorUpdateEquipmentFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_SUCCESS,
        addorUpdateEquipmentSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_FAILURE,
        addorUpdateEquipmentFailure,
      );
    };
  }, []);

  function RenderAddBezeichnung() {
    return (
      <>
        <Button
          variant="outlined"
          id="addEquipmentTest"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addBezeichnung"
        >
          {localization.add}
        </Button>
      </>
    );
  }
  //------------------------Add Bezeichnung end ----------------------

  //------------------------Edit Bezeichnung start ----------------------

  const setCurrentBezeichnungDetails = (row) => {
    setBezeichnungDetails(row);
  };

  function RenderEditButton(props) {
    const currentBezeichnung = props.currentBezeichnung;
    return (
      <>
        <Button
          variant="outlined"
          id="editEquipmentTest"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addBezeichnung"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }
  //------------------------Edit Bezeichnung end ----------------------

  //------------------------Delete Bezeichnung start ----------------------
  useEffect(() => {
    function deleteBezeichnungSuccess() {
      const res = equipmentGroupStore.getDeleteBezeichnung();
      if (res.length === 0) {
        toast.success(localization.equipmentDeletedSuccessfully);
      } else {
        res.forEach((item) => toast.error(item));
      }
      setBezerichnunList(null);
      getEquipmentList();
    }

    function deleteBezeichnungFailure() {
      const res = equipmentGroupStore.getDeleteBezeichnung();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_DESIGNATION_SUCCESS,
      deleteBezeichnungSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_DESIGNATION_FAILURE,
      deleteBezeichnungFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_DESIGNATION_SUCCESS,
        deleteBezeichnungSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_DESIGNATION_FAILURE,
        deleteBezeichnungFailure,
      );
    };
  }, []);

  function deleteBezeichnungCallback(id) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.areYouSureYouWantToDeleteEquipment);
    setCallbackData({
      bezeichnungID: id,
    });
    setEventType("DELETE_BEZEICHNUNG");
  }

  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_BEZEICHNUNG":
          setGlobalSpinner(true);
          const res = EquipmentGroupActions.deleteBezeichnung(
            data.bezeichnungID,
          );
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const closeAddBezeichnungPopUpCallback = () => {
    setBezeichnungDetails("");
  };

  function RenderDeleteButton(props) {
    const id = props.bezeichnungID;
    return (
      <>
        <Button
          variant="outlined"
          id="deleteEquipmentTest"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }

  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteBezeichnungCallback(_idList);
    commonUtils.hideModalPopUp("addBezeichnungModalClose");
  };
  //------------------------Delete Bezeichnung end ----------------------
  const handleAdd = () => {
    setBezeichnungDetails("");
  };

  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: setCurrentBezeichnungDetails,
      },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddBezeichnung />,
        onClick: handleAdd,
      },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };
  function handleImport(seletedFile, eqGId) {
    setGlobalSpinner(true);
    const obj = {
      ImportType: "EquipmentName",
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      setBezerichnunList(null);
      getEquipmentList();
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate(eqGId) {
    ImportAction.getTemplate({
      ImportType: "EquipmentName",
      UpdateTempalte: false,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => setCurrentBezeichnungDetails(params.row)}
        data-toggle="modal"
        data-target="#addBezeichnung"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div
        style={{ height: "100%", width: "100%", overflow: "auto" }}
        id="content"
      >
        <div className="form-group d-flex col-lg-3 align-items-center"></div>
        {bezerichnunList && (
          <CustomDataGrid
            Title={
              localization.equSetting + " / " + localization.nameOfEquipment
            }
            columns={columns}
            rows={bezerichnunList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["bezeichnung"]}
            showCheckBox={true}
            gridTableHeight={"dataGridMedium"}
          />
        )}
        {openImport.isOpen && <ImportComponent data={openImport} />}
      </div>
      <AddBezeichnung
        bezeichnungDetails={bezeichnungDetails}
        closeAddBezeichnungPopUpCallback={closeAddBezeichnungPopUpCallback}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default BezeichnungList;
